import { createFileRoute } from "@tanstack/react-router";
import { CheckEmailPage } from "@/features/auth/pages/CheckEmailPage";

export const Route = createFileRoute("/check-email")({
  validateSearch: (search: Record<string, unknown>): { email?: string } => ({
    email: typeof search.email === "string" ? search.email : undefined,
  }),
  component: CheckEmailPage,
});
